import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import SelectorPopover from './SelectorPopover';
import './Selector.less';


class Selector extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
      PropTypes.string,
      PropTypes.number,
    ]),
    info: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
      PropTypes.string,
      PropTypes.number,
    ]),
    className: PropTypes.string,
    options: PropTypes.object,
    value: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.object),
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.object,
      PropTypes.string,
    ]),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    multi: PropTypes.bool,
    clearable: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    title: '',
    info: '',
    options: [],
    value: [],
    placeholder: '',
    className: '',
    onChange: () => null,
    multi: false,
    clearable: true,
    disabled: false,
  };

  mapToOptions(mapOfOptions) {
    return Object.keys(mapOfOptions).map(instance => ({
      value: instance,
      label: mapOfOptions[instance]
    }));
  }

  render() {
    const {
      title,
      options,
      info,
      value,
      placeholder,
      onChange,
      className,
      multi,
      clearable,
      disabled
    } = this.props;

    const id = title
      .replace(/\s/, '-')
      .toLowerCase();

    return (
      <div className={`selector-container ${className}`} id={id}>
        <label className="selector-label" htmlFor={id}>{title} {info &&
          <SelectorPopover>{info}</SelectorPopover>}
        </label>
        <div className="select-wrapper">
          <Select
            name={id}
            className="selector"
            options={this.mapToOptions(options)}
            clearable={clearable}
            multi={multi}
            simpleValue={true}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={onChange} />
        </div>
      </div>
    );
  }
}

export default Selector;



/** WEBPACK FOOTER **
 ** ./src/components/Modules/Selector/Selector.js
 **/